/**
 * Customer Portal (UI) - shared metric card grid for dashboard variants.
 */
import type { DashboardMetric } from '../../types/portal';

type MetricCardsGridProps = {
  title: string;
  description?: string;
  metrics: DashboardMetric[];
};

export function MetricCardsGrid({ title, description, metrics }: MetricCardsGridProps) {
  return (
    <div className="card">
      <div className="card-header justify-content-center text-center">
        <h3 className="card-title mb-0">{title}</h3>
      </div>
      <div className="card-body text-center">
        {description ? <p className="text-secondary mb-3">{description}</p> : null}
        <div className="row row-cards">
          {metrics.map((metric) => (
            <div className="col-sm-6 col-lg-3" key={metric.key}>
              <div className="card card-sm h-100">
                <div className="card-body text-center">
                  <div className="text-secondary">{metric.label}</div>
                  <div className="h2 mb-1">{metric.value}</div>
                  <div className={`small ${metric.trend === 'down' ? 'text-danger' : 'text-success'}`}>Trend: {metric.trend}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

